import barba from "@barba/core";
import barbaPrefetch from "@barba/prefetch";
import { get } from "animejs";
import anime from "animejs/lib/anime.es.js";

import { animationShutter } from "./animation-shutter";

// head内のmetaタグ書き換え
const replaceHead = function (data) {
  const head = document.head;
  const newPageRawHead = data.next.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0];
  const newPageHead = document.createElement("head");
  newPageHead.innerHTML = newPageRawHead;

  const removeHeadTags = ["meta[name='keywords']", "meta[name='description']", "meta[property^='og']", "meta[name^='twitter']", "meta[itemprop]", "link[itemprop]", "link[rel='prev']", "link[rel='next']", "link[rel='canonical']"].join(",");

  const headTags = head.querySelectorAll(removeHeadTags);

  for (let i = 0; i < headTags.length; i++) {
    head.removeChild(headTags[i]);
  }

  const newHeadTags = newPageHead.querySelectorAll(removeHeadTags);

  for (let i = 0; i < newHeadTags.length; i++) {
    head.appendChild(newHeadTags[i]);
  }
};

// 広告をクリア
const clearAllGAMSlots = () => {
  if (!window.googletag) {
    requestAnimationFrame(function () {
      googletag.cmd.push(function () {
        googletag.pubads().clear();
      });
    });
  }
};

// Google
const refreshGtag = () => {
  // Google Analytics
  if (typeof gtag === "function") {
    // inkrich と ユーザー独自のプロパティが設定される前提
    gtag("config", window.GA_INKRICH_ID, {
      page_path: window.location.pathname,
      dimension1: window.GA_SITE_TYPE,
      dimension2: window.GA_THEME,
    });
    // Google Analytics を設定しないユーザーもいるので設定していたら gtag を追加する
    if (window.GA_USER_ID) {
      gtag("config", window.GA_USER_ID, {
        page_path: window.location.pathname,
      });
    }
  }

  // Google AdSense
  // 参考:https://leap-in.com/ja/how-to-integrate-google-adsense-to-barba-jspjax/
  let gam_opt_divs = window.GAM_OPT_DIVS; // HTMLで定義されている適用ID
  requestAnimationFrame(function () {
    googletag.cmd.push(function () {
      googletag.pubads().refresh(); //広告の更新
      for (var i in gam_opt_divs) {
        googletag.display(gam_opt_divs[i]); //広告の再表示
      }
    });
  });
};

// サイト内遷移時に記事部分のscriptを手動で発火
const refreshEmbedJs = (container) => {
  const scripts = document.body.querySelectorAll("script");
  if (scripts.length === 0) return false;
  const scriptsWrapper = document.createElement("div");

  // インスタグラム初期化 TODO: 要検証
  const article = container.querySelector("[data-article]");
  if (!article) {
    delete window.instgrm;
  }

  // 「LINEで送る」ボタン初期化
  // const line = container.querySelector(".line-it-button");
  // if (line) {
  //   const script = document.createElement("script");
  //   script.innerHTML = LineIt.loadButton();
  //   scriptsWrapper.appendChild(script);
  // }

  for (let i = 0; i < scripts.length; i++) {
    // 開発サーバーbrowser-syncのscriptはスキップする
    if (scripts[i].src === "http://localhost:3002/browser-sync/browser-sync-client.js?v=2.26.13" || scripts[i].id === "__bs_script__") continue;

    const script = document.createElement("script");
    script.async = true;
    script.defer = true;

    if (scripts[i].src) {
      script.src = scripts[i].src;
    } else {
      script.innerHTML = scripts[i].innerHTML;
    }

    scriptsWrapper.appendChild(script);
  }

  container.appendChild(scriptsWrapper);
};

// 同じurlの場合、ページ遷移をさせない
const noTransitionToCurrentPage = () => {
  const eventDelete = (e) => {
    if (e.currentTarget.href === window.location.href) {
      e.preventDefault();
      e.stopPropagation();
      window.scrollTo(0, 0);
      return;
    }
  };

  const links = [...document.querySelectorAll("a[href]")];
  links.forEach((link) => {
    link.addEventListener(
      "click",
      (e) => {
        eventDelete(e);
      },
      false
    );
  });
};

// ページが変わったときのスクロール処理
const initScrollPos = () => {
  if (location.hash) {
    // #の位置で表示
    const scrollEl = window.document.scrollingElement || window.document.body || window.document.documentElement;
    const el = document.getElementById(location.hash.split("#")[1]);
    anime({
      targets: scrollEl,
      scrollTop: el.offsetTop,
      delay: 0,
      duration: 0,
    });
  } else {
    // #がなければスクロールトップへ
    window.scrollTo(0, 0);
  }
};

// ブラウザバック、ブラウザフォワードを検知する
const handlePopstate = (trigger) => trigger === "back" || trigger === "forward" || trigger === "popstate";

// barba.jsの処理
export const initBarba = (handleLoadPage, handleAnimation) => {
  // 画面内のリンクを取得
  barba.use(barbaPrefetch);

  barba.init({
    // ページ遷移が完了するまで別ページへの遷移をキャンセル
    preventRunning: true,

    // エラーを起こす内部リンクにクラスをつける
    requestError: (trigger, action, url, response) => {
      if (action === "enter" && !trigger.classList.contains("js-prevent-barba")) {
        trigger.classList.add("js-prevent-barba");
      }
    },

    // 上記のクラスがついたリンクはbarba遷移しない
    prevent: ({ el }) => el.classList && el.classList.contains("js-prevent-barba"),

    // ページ遷移フック
    transitions: [
      {
        name: "default-transition",
        once() {
          noTransitionToCurrentPage();
          // #付きのURLにブラウザバック、ブラウザフォワード時のスクロール位置の不具合を防止
          if (history.scrollRestoration) history.scrollRestoration = "manual";
        },
        before() {
          clearAllGAMSlots();
        },
        async enter(data) {
          data.next.container.style.opacity = 0;

          // data-barba-namespaceの値が同じなら遷移アニメーションをしない
          if (data.current.namespace !== data.next.namespace && !handlePopstate(data.trigger)) {
            await animationShutter.in();
          }

          // 遷移後
          const container = data.next.container;
          replaceHead(data);
          // refreshEmbedJs(container);
          handleLoadPage(container);
          initScrollPos();
        },
        after(data) {
          data.next.container.style.opacity = "";

          // data-barba-namespaceの値が同じなら遷移アニメーションをしない
          const hasAnimation = () => {
            if (data.current.namespace !== data.next.namespace && !handlePopstate(data.trigger)) {
              return animationShutter.out;
            }
            return false;
          };
          const container = data.next.container;
          handleAnimation(hasAnimation(), container);
          refreshEmbedJs(container);
          refreshGtag(); // 広告の再表示
        },
      },
    ],
  });
};
